import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import SlotInfo from './SlotInfo';
import CoachInfo from './CoachInfo';
import i18n from '../utils/i18n';
import NumberOverText from './NumberOverText';

import './styles/UserBookedEventCardComponent.scss';

const UserBookedSessionCardComponent = ({
  time,
  clubName,
  clubAddress,
  coachName,
  coachPicture,
  availableSpaces,
  participantsGoing,
  sessionName,
  sessionSubname,
  sessionPicture,
  openCancellationConfirmModal
}) => (
  <div className="user-booked-event-card">
    <div className="card-component__upper-event">
      <img
        className="card-component__upper-photo"
        alt=""
        src={ sessionPicture && decodeURIComponent(sessionPicture) }
      />
    </div>
    <div className="lower-session-info">
      <div className="session-details">
        <div className="name">
          {sessionName}
        </div>
        <div className="subname">
          {sessionSubname}
        </div>
      </div>
      <hr />

      <SlotInfo date={ time } clubName={ clubName } address={ clubAddress } />
      <CoachInfo name={ coachName } picture={ coachPicture } />
      <hr />
      <div className="numbers-texts-wrapper">
        <div className="slots-available">
          <NumberOverText
            number={ availableSpaces }
            text={ i18n.t('upcomingBookings.SLOTS_AVAILABLE') }
          />
        </div>
        <div className="participants-going">
          <NumberOverText
            number={ participantsGoing }
            text={ i18n.t('upcomingBookings.PARTICIPANTS_GOING') }
          />
        </div>
      </div>
      <div className="numbers-texts-wrapper-substitute" />
      <div className="bottom-card-text" onClick={ openCancellationConfirmModal }>
        {i18n.t('myDeuceScreen.CANCEL_SESSION')}
        <FontAwesome className="arrow-right" name="arrow-right" />
      </div>
    </div>
  </div>
);

UserBookedSessionCardComponent.propTypes = {
  time: PropTypes.string,
  clubName: PropTypes.string,
  clubAddress: PropTypes.string,
  coachName: PropTypes.string,
  coachPicture: PropTypes.string,
  availableSpaces: PropTypes.number,
  participantsGoing: PropTypes.number,
  sessionName: PropTypes.string,
  sessionSubname: PropTypes.string,
  sessionPicture: PropTypes.string,
  openCancellationConfirmModal: PropTypes.func.isRequired
};

UserBookedSessionCardComponent.defaultProps = {
  time: '',
  clubName: '',
  clubAddress: '',
  coachName: '',
  coachPicture: '',
  availableSpaces: 0,
  participantsGoing: 0,
  sessionName: '',
  sessionSubname: '',
  sessionPicture: ''
};

export default UserBookedSessionCardComponent;



// WEBPACK FOOTER //
// ./src/components/UserBookedSessionCardComponent.js